import { getService } from '@Client/runner.hooks/useService';
import React, { useState, useEffect } from 'react';

interface StatusBadgeProps {
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status: initialStatus }) => {
  const APP_CONFIG = getService('APP_CONFIG');
  const [status, setStatus] = useState(initialStatus);

  useEffect(() => {
    if (initialStatus === 'Public' && !APP_CONFIG.enablePublicProcessMaps) {
      setStatus('Published');
    } else {
      setStatus(initialStatus);
    }
  }, [initialStatus]);

  const getStatusDisplay = () => {
    switch (status) {
      case 'Draft':
        return 'val-badge--draft';
      case 'Published':
        return 'val-badge--published';
      case 'Internal':
        return 'val-badge--published';
      case 'Public':
        return 'val-badge--published-public';
      case 'Public SSO':
      case 'Public Form':
      case 'Awaiting Publish Approval':
        return 'val-badge--published-sso';
      default:
        return '';
    }
  };

  return (
    <div className="flex">
      <span className={`val-badge ${getStatusDisplay()}`} title={status}>
        {status}
      </span>
    </div>
  );
};

export default StatusBadge;
